import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../api/axiosInstance";

const FAQForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [form, setForm] = useState({
    question: "",
    answer: "",
    category: "general",
    order: 0,
    isActive: true
  });

  useEffect(() => {
    if (!id) {
      setLoading(false);
      return;
    }

    const load = async () => {
      try {
        const res = await api.get(`/api/faqs/${id}`);
        setForm(res.data.data);
      } catch {
        alert("Failed to load FAQ");
        navigate("/admin/faqs");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id, navigate]);

  const submit = async (e) => {
    e.preventDefault();

    if (id) {
      await api.put(`/api/faqs/${id}`, form);
    } else {
      await api.post("/api/faqs", form);
    }

    navigate("/admin/faqs");
  };

  if (loading) return <p>Loading...</p>;

  return (
    <form onSubmit={submit} className="max-w-2xl space-y-4">
      <h1 className="text-xl font-bold">
        {id ? "Edit FAQ" : "Create FAQ"}
      </h1>

      <input
        className="w-full border p-2"
        placeholder="Question"
        value={form.question}
        onChange={(e) =>
          setForm({ ...form, question: e.target.value })
        }
      />

      <textarea
        className="w-full border p-2 h-32"
        placeholder="Answer"
        value={form.answer}
        onChange={(e) =>
          setForm({ ...form, answer: e.target.value })
        }
      />

      <select
        className="w-full border p-2"
        value={form.category}
        onChange={(e) =>
          setForm({ ...form, category: e.target.value })
        }
      >
        <option value="general">General</option>
        <option value="pricing">Pricing</option>
        <option value="plans">Plans</option>
        <option value="payments">Payments</option>
      </select>

      <input
        type="number"
        className="w-full border p-2"
        placeholder="Order"
        value={form.order}
        onChange={(e) =>
          setForm({ ...form, order: Number(e.target.value) })
        }
      />

      <label className="flex gap-2">
        <input
          type="checkbox"
          checked={form.isActive}
          onChange={(e) =>
            setForm({ ...form, isActive: e.target.checked })
          }
        />
        Active
      </label>

      <button className="bg-green-600 text-white px-4 py-2 rounded">
        Save
      </button>
    </form>
  );
};

export default FAQForm;
